import { useMutation } from '@tanstack/react-query';
import { deleteTasks } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useDeleteTasksMutation = () =>
  useMutation({
    mutationFn: async (taskIds: ID[]) => deleteTasks(taskIds),
  });
